const MiniForkliftCard = ({ product, onClick }) => {
  const imageUrl = product.img ? process.env.REACT_APP_API_URL + 'static/' + product.img
  : 'https://placehold.co/300x200';

  return (
    <div className="mini-product-card" onClick={onClick}>
      <div className="mini-card-image">
        <img src={imageUrl} alt={product.title}/>
      </div>
      <div className="mini-card-body">
        <h3 className="mini-card-title">{product.title}</h3>
        <p className="mini-card-price">{product.price}</p>
      </div>
    </div>
  );
};

export default MiniForkliftCard;